import { useAuth } from "@/App";
import { useNavigate } from "react-router-dom";
import { Menu, LogOut, User, ArrowLeftRight } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

const FactoryTopbar = ({ onMenuToggle }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const getInitials = (name) => {
    if (!name) return "U";
    return name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2);
  };

  const isSuperAdmin = user?.role === "SUPER_ADMIN";

  return (
    <header
      className="sticky top-0 z-40 h-16 bg-[#1C2B2B] border-b border-emerald-900/40 flex items-center justify-between px-4 sm:px-6"
      data-testid="factory-topbar"
    >
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuToggle}
          className="text-slate-400 hover:text-white p-2 rounded-lg hover:bg-white/5"
          data-testid="factory-menu-toggle"
        >
          <Menu className="w-5 h-5" />
        </button>
        <h1 className="text-white text-lg font-semibold hidden sm:block">
          Factory Operations
          {user?.assigned_unit && (
            <span className="ml-2 text-sm font-normal text-emerald-400 bg-emerald-900/30 px-2 py-0.5 rounded">
              {user.assigned_unit}
            </span>
          )}
        </h1>
      </div>

      <div className="flex items-center gap-3">
        {isSuperAdmin && (
          <button
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-emerald-600/20 text-emerald-400 hover:bg-emerald-600/30 text-sm transition-colors"
            data-testid="switch-to-sales"
          >
            <ArrowLeftRight className="w-4 h-4" />
            <span className="hidden sm:inline">Sales Panel</span>
          </button>
        )}

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex items-center gap-2 p-1 rounded-lg hover:bg-white/5" data-testid="factory-user-menu">
              <Avatar className="h-8 w-8">
                <AvatarFallback className="bg-emerald-600 text-white text-xs">
                  {getInitials(user?.name)}
                </AvatarFallback>
              </Avatar>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuLabel>
              <p className="text-sm font-medium">{user?.name || "User"}</p>
              <p className="text-xs text-muted-foreground">{user?.email}</p>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout} className="text-red-600" data-testid="factory-logout-btn">
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default FactoryTopbar;
